import type { SelectionPage } from '@tilelist/application/ports/SelectionEvents.ts';

export function selectionParams(attributes: Record<string, string | string[]>): URLSearchParams {
    validateRule(attributes.rule);
    const params = new URLSearchParams();
    for (const [key, value] of Object.entries(attributes)) {
        if (typeof value === 'string') params.append(key, value);
        else if (Array.isArray(value) && value.every((entry) => typeof entry === 'string')) {
            value.forEach((entry) => params.append(key, entry));
        } else throw new Error(`Unsupported selection field "${key}"`);
    }
    return params;
}

export function validateRule(rule: unknown): asserts rule is string {
    if (typeof rule !== 'string' || !rule || rule === 'undefined' || rule === 'null') throw new Error('Invalid rule');
}

export function pageFromAttributes(attributes: Record<string, string | string[]>): SelectionPage {
    return orderedPage({
        layout: first(attributes.l),
        offset: first(attributes.o),
        sortOrder: first(attributes.sortiertnach),
        comparisonId: first(attributes.c),
    });
}

export function pageFromUrl(url: string): SelectionPage {
    const params = new URL(url, window.location.origin).searchParams;
    return orderedPage({
        layout: params.get('l') || undefined,
        offset: params.get('o') || undefined,
        sortOrder: params.get('sortiertnach') || undefined,
        comparisonId: params.get('c') || undefined,
    });
}

export function orderedPage(page: SelectionPage): SelectionPage {
    return {
        ...(page.layout !== undefined ? { layout: page.layout } : {}),
        ...(page.offset !== undefined ? { offset: page.offset } : {}),
        ...(page.sortOrder !== undefined ? { sortOrder: page.sortOrder } : {}),
        ...(page.comparisonId !== undefined ? { comparisonId: page.comparisonId } : {}),
    };
}

function first(value: string | string[] | undefined): string | undefined {
    return Array.isArray(value) ? value[0] : value;
}
